import { render } from "./ContactsPage.vue?vue&type=template&id=f0eab088&ts=true"
import script from "./ContactsPage.vue?vue&type=script&lang=ts"
export * from "./ContactsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__